import { render, staticRenderFns } from "./VehiclePopup.vue?vue&type=template&id=0a819b00&scoped=true&"
import script from "./VehiclePopup.vue?vue&type=script&lang=js&"
export * from "./VehiclePopup.vue?vue&type=script&lang=js&"
import style0 from "./VehiclePopup.vue?vue&type=style&index=0&id=0a819b00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a819b00",
  null
  
)

export default component.exports